import React from 'react';
import { Container, Box } from '@mui/material';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '../components/DashboardLayout';
import { AdminFoodTab } from '@pages/admin/AdminLibraryPage/AdminFoodTab';

export const AdminFoodsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Container maxWidth={false} data-i-doc={PageIndices.ADMIN_FOODS}>
        <Box sx={{ width: '100%' }}>
          <AdminFoodTab />
        </Box>
      </Container>
    </DashboardLayout>
  );
};
